exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-position {\n  position: absolute;\n  z-index: 10000;\n  width: 81%;\n  margin-top: 14%; }\n  .spinner-position small {\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/upload-awards/upload-awards.component.scss
// module id = ../../../../../src/app/components/upload-awards/upload-awards.component.scss
// module chunks = main